"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportOwnerDetailToJSON = exports.StoreImportOwnerDetailFromJSONTyped = exports.StoreImportOwnerDetailFromJSON = exports.instanceOfStoreImportOwnerDetail = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreImportOwnerDetail interface.
 */
function instanceOfStoreImportOwnerDetail(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImportOwnerDetail = instanceOfStoreImportOwnerDetail;
function StoreImportOwnerDetailFromJSON(json) {
    return StoreImportOwnerDetailFromJSONTyped(json, false);
}
exports.StoreImportOwnerDetailFromJSON = StoreImportOwnerDetailFromJSON;
function StoreImportOwnerDetailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organizerEmail': !(0, runtime_1.exists)(json, 'organizer_email') ? undefined : json['organizer_email'],
    };
}
exports.StoreImportOwnerDetailFromJSONTyped = StoreImportOwnerDetailFromJSONTyped;
function StoreImportOwnerDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'organizer_email': value.organizerEmail,
    };
}
exports.StoreImportOwnerDetailToJSON = StoreImportOwnerDetailToJSON;
